import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { advancedFilterList } from '@ifca-root/react-component/src/components/Filter/AdvancedFilter';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import IconText from '@ifca-root/react-component/src/components/Typography/IconText';
import { amtStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter';
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@material-ui/core';
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { ApprovalLogDialog } from 'components/Dialog/ApprovalLogDialog';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { useColorStatusList } from 'helpers/Hooks/useColorStatusList';
import { useMenuOption } from 'helpers/Hooks/useMenuOption';
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import React, { Fragment, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory, useParams } from 'react-router';
import SubmitterLog from '../../../assets/icons/submitter-log.svg';
import { DeleteDialog } from '../../../containers/GeneralSettingModule/Item/components/DeleteDialog';
import {
  ApprovalStatus,
  useDeleteGrtnMutation,
  useGetDocNumTitleQuery,
} from '../../../generated/graphql';
import {
  formatDate,
  formatTime,
} from '../../../helpers/StringNumberFunction/formatDate';

export interface CancelCloseProps {
  CancelCloseDate: string;
  CancelCloseRemark: string;
}

export const GeneralGRTNEntryList = (props: any) => {
  const {
    filteredList,
    condition,
    userList,
    listStatus,
    listStatusOptions,
    createPermissionCheck,
    updatePermissionCheck,
    deletePermissionCheck,
    labelState,
    setOriginalListing,
    loadData,
    listLoading,
    selectedField,
    sortOrder,
  } = props;

  const companyStatus = localStorage?.getItem('companyStatus');
  let history = useHistory();
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'));
  const { CompanyID }: any = useParams();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
  const { handleStatusColor, handleStatusRename } = useColorStatusList();
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openWorkFlow, setWorkFlow] = useState(false);
  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);
  const { setOpenSnackBar, setSnackBarMsg } = useContext(
    SnackBarContext,
  ) as any;
  const [errDeleteDialog, setErrDeleteDialog] = useState(false);

  const {
    handleSubmit,
    control,
    register,
    setValue,
    watch,
    setError,
    clearErrors,
    errors,
    reset,
  } = useForm<CancelCloseProps>({
    mode: 'onSubmit',
  });

  const {
    loading: docNumHeaderLoading,
    error: docNumHeaderError,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'GP_GRTNHeader' },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const docNumChecker = getDocumentNumberHeader?.length === 0;
  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker();

  const [deleteGRTN, { loading: deleteGRTNLoading }] = useDeleteGrtnMutation({
    onError: ({ message }) => {
      setOpenDelete(false);
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDeleteDialog(true);
    },
    onCompleted: data => {
      setOpenSnackBar(true);
      setOpenDelete(false);
      setSnackBarMsg(SystemMsgs.deleteRecord());
      setTimeout(() => {
        history.push({
          pathname: `/general-purchase/${CompanyID}/good-return-note`,
          state: { success: true, msgMode: 'delete' },
        });
      }, 500);
      setOriginalListing([]);
      loadData({
        variables: {
          CompanyID: CompanyID,
          StatusArr: 'ACTIVE',
          take: 30,
          skip: 0,
          RoleID: user?.roleDetail?.RoleID,
          ...(getSearch?.name && { searchValue: getSearch?.name }),
          sortField: selectedField === null ? undefined : selectedField,
          sortOrder: sortOrder === null ? undefined : sortOrder,
        },
      });
    },
  });

  const handleDelete = data => {
    deleteGRTN({ variables: { GRTNHeaderID: data, CompanyID } });
  };

  return (
    <>
      {deleteGRTNLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      <ContentWrapper float overflow>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length;
                loadData({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr:
                      listStatus === 'ALL' ? listStatusOptions : [listStatus],
                    take: 30,
                    skip: currentLength,
                    RoleID: user?.roleDetail?.RoleID,
                    searchValue:
                      getSearch?.name !== '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                    sortField: selectedField === null ? null : selectedField,
                    sortOrder: sortOrder === null ? null : sortOrder,
                  },
                });
              }}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList).map((el, index) => {
                const rfqsubSupID = el?.RFQSupplierInvitation?.map(
                  v => v?.SupplierID,
                );

                const returnedAmtArray =
                  el?.GRTNHeaderItem?.map(x => x?.ReturnedAmt) || [];

                const TotalAmt = returnedAmtArray.reduce(
                  (accumulator, currentValue) =>
                    (accumulator || 0) + (currentValue || 0),
                  0,
                );
                return (
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span
                            className={`xsTitle flex-space
                            ${el?.ApprovalStatus === ApprovalStatus.Completed &&
                              'click-text'}
                          `}
                            onClick={() => {
                              history.push(
                                `/general-purchase/${CompanyID}/good-return-note/${el?.GRTNHeaderID}/detail/preview`,
                              );
                            }}
                          >
                            {el?.DocNo || el?.RefNo}
                          </span>
                          <span className="desc">
                            {`${formatDate(el?.DocDate)}`}
                          </span>
                        </>
                      }
                      secondary={
                        <Grid container className="desc flex-space text-noflow">
                          {/* {listStatus === 'COMPLETED' && ( */}
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={8}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.Supplier?.CompanyName}
                              </span>
                            </Grid>
                            <Grid item xs={4}>
                              <IconText
                                parentStyle={{ justifyContent: 'end' }}
                                font="xxTitle c-orange"
                                children={amtStr(TotalAmt)}
                              />
                            </Grid>
                          </Grid>
                          {/* )} */}

                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={8}>
                              <div className="icon-text">
                                <Tooltip
                                  disableFocusListener
                                  title={
                                    <Fragment>
                                      <Grid container wrap="nowrap" spacing={2}>
                                        <Grid item>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          ></IconText>
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                          <div style={{ fontSize: '12px' }}>
                                            {userList?.find(
                                              x => x?.ID === el?.createdBy,
                                            )?.name ??
                                              userList?.find(
                                                x =>
                                                  x?.ID ===
                                                  (el?.createdBy ?? el?.modBy),
                                              )?.name}
                                          </div>
                                          <div style={{ fontSize: '10px' }}>
                                            {formatDate(
                                              el?.modTs ?? el?.createdTs,
                                            )}
                                            &nbsp;
                                            {formatTime(
                                              el?.modTs ?? el?.createdTs,
                                            )}
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Fragment>
                                  }
                                  arrow
                                  enterTouchDelay={0}
                                >
                                  <div>
                                    <IconText
                                      icon={
                                        <img
                                          src={SubmitterLog}
                                          style={{
                                            width: '12px',
                                            marginRight: '3px',
                                          }}
                                        />
                                      }
                                      font="desc"
                                    ></IconText>
                                  </div>
                                </Tooltip>

                                <span className="desc text-noflow">
                                  {el?.Description}
                                </span>
                              </div>
                            </Grid>

                            <Grid
                              item
                              xs={4}
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                              }}
                            >
                              <IconButton
                                style={{
                                  padding: '0px',
                                  paddingRight: '5px',
                                }}
                                className="desc"
                                onClick={e => {
                                  handleClick(e, el?.GRTNHeaderID, index, el);
                                  setWorkFlow(true);
                                }}
                              >
                                <ListAltIcon style={{ fontSize: '13px' }} />
                              </IconButton>
                              <span
                                className="desc"
                                style={{
                                  color: `${handleStatusColor(
                                    el?.ApprovalStatus,
                                  )}`,
                                }}
                              >
                                {handleStatusRename(el?.ApprovalStatus)}
                              </span>
                            </Grid>
                          </Grid>
                          {listStatus === 'ALL' && (
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={12}>
                                <IconText
                                  parentStyle={{
                                    justifyContent: 'end',
                                    color: `${handleStatusColor(
                                      el?.ApprovalStatus,
                                    )}`,
                                  }}
                                  font="xxTitle"
                                  children={handleStatusRename(
                                    el?.ApprovalStatus,
                                  )}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      }
                    />
                    <ListItemSecondaryAction>
                      {listStatus === 'ACTIVE' || listStatus === 'REJECTED' ? (
                        <>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(e, el?.GRTNHeaderID, index, el)
                            }
                            style={{ verticalAlign: '35px', marginTop: '40px' }}
                          >
                            <MoreVert />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton edge="end" aria-label="arrow">
                          <KeyboardArrowRight
                            onClick={() => {
                              history.push({
                                pathname: `/general-purchase/${CompanyID}/good-return-note/${el?.GRTNHeaderID}/detail`,
                                state: el,
                              });
                            }}
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>
      {listStatus === 'ACTIVE' && (
        <FloatButton
          // disabled={handlePermDisabled({
          //   companyID: CompanyID, // later change to CompanyID
          //   permEnum: createPermissionCheck,
          // })}

          onClick={() => {
            if (docNumChecker) {
              setOpenSnackBar(true);
              setSnackBarMsg(SystemMsgs.errorNumberingStructure());
            } else {
              history.push(
                `/general-purchase/${CompanyID}/good-return-note/add`,
              );
            }
          }}
          disabled={
            companyStatus === 'INACTIVE' ||
            handlePermDisabled({
              companyID: CompanyID, /// later change to CompanyID
              permEnum: createPermissionCheck,
            })
              ? true
              : false
          }
        />
      )}
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        {listStatus === 'ACTIVE' && (
          <>
            <MenuItem
              // disabled={handlePermDisabled({
              //   companyID: '',
              //   permEnum: updatePermissionCheck,
              // })}
              disabled={
                companyStatus === 'INACTIVE' ||
                handlePermDisabled({
                  companyID: CompanyID, // later change to CompanyID
                  permEnum: updatePermissionCheck,
                })
                  ? true
                  : false
              }
              onClick={() =>
                history.push({
                  pathname: `/general-purchase/${CompanyID}/good-return-note/edit/${menu?.ID}`,
                  state: menu?.obj,
                })
              }
            >
              Edit
            </MenuItem>
            <MenuItem
              // disabled={handlePermDisabled({
              //   companyID: '',
              //   permEnum: deletePermissionCheck,
              // })}
              disabled={
                companyStatus === 'INACTIVE' ||
                handlePermDisabled({
                  companyID: CompanyID,
                  permEnum: deletePermissionCheck,
                })
                  ? true
                  : false
              }
              onClick={() => {
                setOpenDelete(true);
              }}
            >
              <span className="">Delete</span>
            </MenuItem>
          </>
        )}
        {listStatus === 'REJECTED' && (
          <MenuItem
            // disabled={handlePermDisabled({
            //   companyID: '',
            //   permEnum: updatePermissionCheck,
            // })}
            disabled={
              companyStatus === 'INACTIVE' ||
              handlePermDisabled({
                companyID: CompanyID, // later change to CompanyID
                permEnum: updatePermissionCheck,
              })
                ? true
                : false
            }
            onClick={() =>
              history.push({
                pathname: `/general-purchase/${CompanyID}/good-return-note/edit/${menu?.ID}`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }
          >
            Resubmit
          </MenuItem>
        )}
        {listStatus === 'COMPLETED' && (
          <>
            <MenuItem
              // disabled={handlePermDisabled({
              //   companyID: CompanyID, // later change to CompanyID
              //   permEnum: updatePermissionCheck,
              // })}
              onClick={() => {
                history.push({
                  pathname: `/general-purchase/${CompanyID}/rfq/${menu?.ID}`,
                  state: menu?.obj,
                });
              }}
            >
              <span className="">View</span>
            </MenuItem>
            <MenuItem
              // disabled={handlePermDisabled({
              //   companyID: CompanyID, // later change to CompanyID
              //   permEnum: updatePermissionCheck,
              // })}
              onClick={() => {
                history.push({
                  pathname: `/general-purchase/${CompanyID}/rfq/${menu?.ID}/Evaluation-&-Selection`,
                  state: menu?.obj,
                });
              }}
            >
              <span className="">Review Selection</span>
            </MenuItem>
          </>
        )}
      </Menu>
      <ApprovalLogDialog
        data={menu}
        setWorkFlow={setWorkFlow}
        openWorkFlow={openWorkFlow}
        moduleName="Goods Return Note"
        reset={reset}
        handleClose={() => handleClose()}
      />
      <DeleteDialog
        ID={menu?.ID}
        openDialog={openDelete}
        setOpenDialog={setOpenDelete}
        title={'Goods Return Note'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        action={'Delete'}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      <ErrorDialog
        errorDia={errDeleteDialog}
        setErrorDia={setErrDeleteDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
        isBool
        onclick={() => {
          setErrDeleteDialog(false);
          window.location.reload();
        }}
      />
    </>
  );
};
